<ng-form name="options" class="page-fix-form-italic-options">
    <div class="px-4 py-6">
        <h2 class="mt-0" translate>Repair options</h2>

        <div class="mb-4">
            <p class="text-bold mb-1" translate>Preview</p>
            <p class="inline-block my-0 preview">
                &lt;{{getElementText()}}&gt;<span [innerHTML]="previewText"></span>&lt;/{{getElementText()}}&gt;
            </p>
        </div>

        <div class="row form-group">
            <label class="col-48 text-bold mb-1" id="class_option" translate>Default fix</label>
            <div class="col-48">
                <div class="d-flex align-items-center setting-container"
                     [class.active]="replacementSetting === 0"
                     (click)="setReplacementSetting(0)">
                    <p class="my-0 pr-3" translate>Replace all &lt;i&gt; tags</p>
                    <div class="d-flex">
                        <angular-selector
                                class="standard-input"
                                [disableSearch]="true"
                                [removeButton]="false"
                                labelAttr="name"
                                valueAttr="value"
                                [options]="classOptions"
                                [(ngModel)]="classOptionValue"
                                [name]="'classOption'"
                                monId="class_option">
                        </angular-selector>
                    </div>
                    <div class="pl-1">
                        &nbsp;<span translate>with &lt;em&gt;</span>
                    </div>
                    <div class="flex-fill">
                        <span class="fas fa-question-circle fa-fw"
                              aria-hidden="true"
                              ngbTooltip="{{ 'Choose a tag to replace your italic tags with' | translate }}">
                        </span>
                    </div>
                    <div class="pl-4 pt-1 pr-1">
                            <input type="radio"
                                   [attr.aria-label]="'Default fix' | translate"
                                   [(ngModel)]="replacementSetting"
                                   name="defaultFix"
                                   [value]="0"/>
                    </div>
                </div>
            </div>
        </div>

        <p class="text-bold mb-1" translate>Custom settings</p>
        <div class="row form-group">
            <div class="col-48">
                <div class="d-flex align-items-center setting-container"
                     [class.active]="replacementSetting === 1"
                     (click)="setReplacementSetting(1)">
                    <div class="flex-fill pr-3" *ngIf="replacementSetting !== 1">
                        <span translate>Choose this option to customise the fix</span>
                    </div>
                    <div class="flex-fill" *ngIf="replacementSetting === 1">
                        <p class="my-0">
                            <span translate>Change your &lt;i&gt; elements into something else</span><span class="fas fa-question-circle"
                                ngbTooltip="{{ 'Instead of &lt;i&gt; choose a different element name to be used instead' | translate }}"
                                aria-hidden="true">
                            </span>
                        </p>
                        <div class="mt-3">
                            <div class="d-flex flex-grow-1 align-items-center">
                                <p class="my-0 pr-3" translate>Replace all &lt;i&gt; tags</p>
                                <div class="pr-1">
                                    <angular-selector
                                            class="standard-input"
                                            [disableSearch]="true"
                                            [removeButton]="false"
                                            labelAttr="name"
                                            valueAttr="value"
                                            [options]="classOptions"
                                            [(ngModel)]="classOptionValue"
                                            [name]="'classOption'">
                                    </angular-selector>
                                </div>
                                <div>
                                    <span translate>with</span>
                                </div>
                                <div class="pl-1">
                                    <input type="text"
                                           [required]="replacementSetting === 1"
                                           [pattern]="replacementRegex"
                                           [placeholder]="'Write custom tag' | translate"
                                           class="form-control standard-input"
                                           [attr.id]="'custom_element'"
                                           name="customElement"
                                           [disabled]="replacementSetting !== 1"
                                           (input)="updatePreview()"
                                           [(ngModel)]="customElement"/>
                                </div>
                                <div>
                                    <form-field-errors *ngIf="replacementSetting === 1"
                                               offset="0"
                                               [patternMsg]="'Element name is invalid' | translate">
                                    </form-field-errors>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 mb-1">
                            <p class="my-0">
                                <span translate>Add attributes to be excluded in this change</span><span class="fas fa-question-circle"
                                    ngbTooltip="{{ '&lt;i&gt; tags with these attribute values will not be changed' | translate }}"
                                    aria-hidden="true">
                                </span>
                            </p>
                        </div>
                        <div class="mt-1"
                             *ngFor="let selector of extraSelectors; let i = index; trackBy: trackByIndex">
                            <div class="d-flex align-items-center"
                                 *ngIf="!(classOptionValue === defaultClassOptionValue && selector.type === attributesData.class.key)">
                                <div class="pr-1">
                                    <angular-selector
                                            class="standard-input"
                                            [disableSearch]="true"
                                            labelAttr="name"
                                            valueAttr="value"
                                            [options]="elementAttributes"
                                            [(ngModel)]="selector.type"
                                            [required]="true"
                                            [name]="'elementAttributes_' + i">
                                    </angular-selector>
                                </div>
                                <div>
                                    <label class="mb-0" [attr.for]="'extra_selector_' + i" translate>Value:</label>
                                </div>
                                <div class="pl-1">
                                    <input type="text"
                                           [pattern]="attributesData[selector.type].regexPattern"
                                           [placeholder]="attributesData[selector.type].inputPlaceholder"
                                           class="form-control standard-input"
                                           [attr.id]="'extra_selector_' + i"
                                           [name]="'extra_selector_' + i"
                                           [(ngModel)]="selector.value"/>
                                </div>
                                <div class="pl-1">
                                    <button class="btn btn-border-radius btn-secondary"
                                            type="button"
                                            (click)="removeRow(i)"
                                            ngbTooltip="{{ 'Remove row' | translate}}">
                                        <span class="sr-only" translate>Remove row</span>
                                        <span class="far fa-trash-alt" aria-hidden="true"></span>
                                    </button>
                                </div>
                                <div>
                                    <form-field-errors offset="0"
                                                       [patternMsg]="attributesData[selector.type].regexError">
                                    </form-field-errors>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button type="button"
                                    class="btn btn-border-radius btn-secondary"
                                    (click)="addRow()"
                                    ngbTooltip="{{ 'Add row' | translate}}">
                                <span class="sr-only" translate>
                                    Add row
                                </span>
                                <span class="fas fa-plus"></span>
                            </button>
                        </div>
                    </div>
                    <div class="pl-4 pt-1 pr-1">
                        <input type="radio"
                               [attr.aria-label]="'Custom settings' | translate"
                               [(ngModel)]="replacementSetting"
                               name="customSettings"
                               [value]="1"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-form>
